<div >
  <h4 class="card-title">{{'RMA.vociDiCosto.title'  | translate}}</h4>
  <div class="p-3" *ngIf="!isModifyDisabled" >
    <div class="row">
      <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
        <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="add()" type="button">{{'RMA.vociDiCosto.add'  | translate}}</button>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
      <tr>
        <th>{{'RMA.vociDiCosto.voce'  | translate}}</th>
        <th scope="col">{{'RMA.vociDiCosto.um'  | translate}}</th>
        <th scope="col">{{'RMA.vociDiCosto.quantita'  | translate}}</th>
        <th scope="col">{{'RMA.vociDiCosto.prezzo'  | translate}}</th>
        <th scope="col">{{'RMA.vociDiCosto.totale'  | translate}}</th>
        <th scope="col" *ngIf="!isModifyDisabled" >{{'RMA.vociDiCosto.azioni'  | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of myProp">
        <td >
            <span *ngIf="!item.modifica" >
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i-feather name="info" class="feather-sm"></i-feather>
              </span>
              {{ item.voce }}
            </span>
          <span *ngIf="item.modifica">
              <input [(ngModel)]="item.voce" placeholder="{{'RMA.vociDiCosto.voce'  | translate}}" type="text" name="voce" class="form-control">
            </span>
        </td>
        <td class="align-middle" >
            <span *ngIf="!item.modifica">
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-euro-sign"></i>
              </span>
              {{ item.um }}
            </span>
          <span *ngIf="item.modifica">
              <input [(ngModel)]="item.um" placeholder="{{'RMA.vociDiCosto.um'  | translate}}" type="text" name="um" class="form-control">
            </span>
        </td>
        <td class="align-middle" >
            <span *ngIf="!item.modifica">
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i-feather name="list" class="feather-sm"></i-feather>
              </span>
              {{ item.quantita}}&nbsp;{{ item.um }}
            </span>
          <span *ngIf="item.modifica">
              <input [(ngModel)]="item.quantita" placeholder="{{'RMA.vociDiCosto.quantita'  | translate}}" type="number" name="quantita" class="form-control">
            </span>
        </td>
        <td class="align-middle" >
            <span *ngIf="!item.modifica">
              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                <i class="fas fa-euro-sign"></i>
              </span>
              {{ item.prezzo | number: '2.2-2'}}
            </span>
          <span *ngIf="item.modifica">
              <input [(ngModel)]="item.prezzo" placeholder="{{'RMA.vociDiCosto.prezzo'  | translate}}" type="number" name="prezzo" class="form-control">
            </span>
        </td>

        <td class="align-middle" >
            <span >
<!--              <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--                <i class="fas fa-euro-sign"></i>-->
<!--              </span>-->
              {{ item.totale | number: '2.2-2'}} €
            </span>
        </td>
        <td class="align-middle" *ngIf="!isModifyDisabled" >
          <a *ngIf="!item.modifica"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
             (click)='edit(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
            <i-feather name="check" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!item.modifica" href="javascript:void(0)" ngbTooltip="Elimina"
             class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="annulla"
             class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
            <i  class="fas fas fa-times"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-end">
    <span class="text-dark font-16 ">Totale: {{getTotale(myProp) | number: '2.2-2'}} €</span>
  </div>
</div>

